import React from 'react';
import PropTypes from 'prop-types';
import { OverlayTrigger, Popover } from 'react-bootstrap';
import classNames from 'classnames';

import './styles/ReviewRatingCell.scss';

const ReviewRatingCell = ({ className, value, scores }) => {
  const popover = (
    <Popover>
      <Popover.Header as='h3'>Reader Scores</Popover.Header>
      <Popover.Body>
        {scores.length > 0 ? (
          scores.map(score => (
            <div key={score.reader}>
              <span className='review-rating-cell__reader' key={score.reader}>
                {score.reader}
                :&nbsp;
              </span>
              <span>{score.rating}</span>
            </div>
          ))
        ) : (
          <div>
            {value === '-' ? 'Rating criteria does not apply to this student' : 'None'}
          </div>
        )}
      </Popover.Body>
    </Popover>
  );

  return (
    <OverlayTrigger placement='top' overlay={popover}>
      <td className={classNames(className, 'review-rating-cell')}>{value}</td>
    </OverlayTrigger>
  );
};

ReviewRatingCell.propTypes = {
  /** className prop */
  className: PropTypes.string,

  /** Cell value */
  value: PropTypes.string,

  /** Student Review Scores */
  scores: PropTypes.arrayOf(
    PropTypes.shape({
      reader: PropTypes.string,
      rating: PropTypes.number
    })
  )
};

ReviewRatingCell.defaultProps = {
  className: '',
  value: '',
  scores: []
};

export default ReviewRatingCell;
